<script>
  export let dropdownItems = []
  export let disableAttributeButton
  export let parsedJson
  export let tempJson
  export let padding = 0
  export let parent = ""
  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showDropdown = false
  /**
   * @type {String} the default or active value in the dropdown area
   */
  export let activeItem = "None"
  /**
   * @type {undefined} binded the overall dropdown parent element
   */
  let dropdown

  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
  $: checkActiveItem(activeItem)

  const checkActiveItem = (activeItem) => {
    if (activeItem && activeItem != "None" && Object.keys(parsedJson[activeItem])) {
      tempJson = Object.keys(parsedJson[activeItem])
      parent = typeof parsedJson[activeItem] == "object" ? activeItem : parent
    }
  }

  $: checkParent(parent)

  const checkParent = (parent) => {
    if (typeof parsedJson[activeItem] != "object") {
      activeItem = "None"
      disableAttributeButton = true
    } else {
      disableAttributeButton = false
    }
  }
</script>

<svelte:window on:click={onCloseDropDown} />

<div class="relative w-full" bind:this={dropdown}>
  <button
    id="attDropDown"
    type="button"
    class="relative w-full"
    on:click={() => {
      showDropdown = !showDropdown
    }}
    style="padding-left: {padding}px;"
  >
    <input name="attribute" bind:value={activeItem} readonly class="w-full cursor-pointer rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-left text-sm text-gray-200 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm" />
    <div class="absolute inset-y-0 right-0 flex aspect-square items-center justify-center text-white">
      <i class="fa-solid fa-chevron-down" />
    </div>
  </button>
  <ul style="padding-inline-start:0px;left: {padding}px; width:{344 - padding}px" class:hidden={!showDropdown} class="absolute z-10 mt-2 max-h-56 flex-col overflow-auto rounded-md border border-none bg-gray-f00 text-start text-sm ring-2 focus:outline-none" tabindex="-1">
    {#each dropdownItems as item}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <li
        on:click={(e) => {
          disableAttributeButton = false
          activeItem = item
          showDropdown = false
        }}
        class="cursor-pointer select-none rounded-md bg-transparent py-2 pl-3 pr-9 text-sm font-bold text-gray-g00 hover:bg-gray-e00 hover:text-extraBlue-500"
      >
        {item}
      </li>
    {/each}
  </ul>
</div>

{#if activeItem != "None" && tempJson[0] != 0 && Object.keys(tempJson).length && typeof parsedJson[activeItem] == "object"}
  <svelte:self bind:disableAttributeButton dropdownItems={tempJson} parsedJson={parsedJson[activeItem]} {tempJson} padding={10} {parent} />
{/if}
